module.exports = __webpack_public_path__ + "static/media/stella-proxies-performance.png.dcb8585a.jpg";